import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
  { path: '/calendar', title: 'Calendar', icon: 'event', class: '' },
    { path: '/clients', title: 'Clients',  icon: 'people', class: '' },
    { path: '/cases', title: 'Cases', icon: 'gavel', class: '' },
    { path: '/diaries', title: 'Diaries', icon: 'book', class: '' },
    { path: '/districts', title: 'Districts', icon: 'location_city', class: '' },
    { path: '/court-types', title: 'Court Types', icon: 'account_balance', class: '' },
    { path: '/case-types', title: 'Case Types', icon: 'folder', class: '' },
    { path: '/todos', title: 'Todo', icon: 'assignment', class: '' },
  { path: '/expenses', title: 'Expenses', icon: 'receipt', class: '' },
    { path: '/transactions', title: 'Transactions', icon: 'account_balance_wallet', class: '' },
  { path: '/contact-us', title: 'Contact Us', icon: 'contact_mail', class: '' },
    
  //   { path: '/user-profile', title: 'User Profile',  icon:'person', class: '' },
  //   { path: '/table-list', title: 'Table List',  icon:'content_paste', class: '' },
  //   { path: '/typography', title: 'Typography',  icon:'library_books', class: '' },
  //   { path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
  //   { path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
  //   { path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
  //  { path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  standalone: false
})
export class SidebarComponent implements OnInit {
  menuItems: any[] | undefined;
  isSidebarCollapsed: boolean = false;
  public readonly SIDEBAR_STATE_KEY = 'sidebarCollapsed';

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.loadSidebarState();
  }

  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  }

  toggleSidebar(): void {
    // Only toggle on desktop screens (width > 991px)
    if ($(window).width() > 991) {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
      this.saveSidebarState();
      this.applySidebarState();
    }
  }

  private loadSidebarState(): void {
    const savedState = localStorage.getItem(this.SIDEBAR_STATE_KEY);
    if (savedState !== null) {
      this.isSidebarCollapsed = savedState === 'true';
      this.applySidebarState();
    }
  }

  private saveSidebarState(): void {
    localStorage.setItem(this.SIDEBAR_STATE_KEY, this.isSidebarCollapsed.toString());
  }

  private applySidebarState(): void {
    const body = document.getElementsByTagName('body')[0];
    if (this.isSidebarCollapsed) {
      body.classList.add('sidebar-mini');
    } else {
      body.classList.remove('sidebar-mini');
    }
  }
}
